;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import svg from "../assets/inPersonIcon.svg"
import SvgAsset from "./SvgAsset"

function InPersonIcon({ isGroupCard, color }) {
  return (
    <SvgAsset
      svg={svg}
      viewBox="0 0 25 31"
      width={isGroupCard ? "13px" : "25px"}
      height={isGroupCard ? "16px" : "31px"}
      color={color ? color : "#AAAAAA"}
    />
  )
}
export default InPersonIcon
